<template>
  <div class="layout">
    <!-- 顶部栏 -->
    <layout-header :avatarInfo="avatarInfo" :isOpenLeftMenu.sync="isOpenLeftMenu"/>
    <!-- 侧边菜单栏 是弹出的 不占位置的 -->
    <layoutAside :isOpenLeftMenu.sync="isOpenLeftMenu"/>
    <!-- 下面的内容插槽 -->
    <slot></slot>
  </div>
</template>

<script>
import * as api from '~/api'
import layoutHeader from './header'
import layoutAside from './aside'
export default {
  data () {
    return {
      // 是否打开侧边栏
      isOpenLeftMenu: false,
      // 用户的个人信息
      avatarInfo: {}
    }
  },
  components: {
    layoutHeader,
    layoutAside
  },
  mounted () {
    // 获取用户的个人信息
    this.getAccountInfo()
  },
  methods: {
    /**
     * 获取个人信息
     * is_first: 是否是第一次进入学识云：1 是第一次 / 0 不是第一次
     */
    getAccountInfo () {
      api.getAccountInfo().then(res => {
        if (res.data.code === 0) {
          // console.log('用户的个人信息', res.data.data)
          // 如果用户是第一次进入的话 需要 打开侧边 进行 引导
          this.avatarInfo = res.data.data
          this.$store.commit('SET_USER_INFO', res.data.data)
          // 更新用户登录时间
          this.updateAccountLoginTime()
        }
      }).catch(err => {
        this.$message.error('网络错误，请重试！')
        console.log(err)
      })
    },
    // 更新用户登录时间
    updateAccountLoginTime () {
      api.updateAccountLoginTime().then(res => {
        if (res.data.code === 0) {
          // console.log('更新用户登录时间成功！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue